import { FieldConditionalFormatting } from '@feature/smart-reports-core/components/field-conditional-formatting/field-conditional-formatting.component';

export type KeyType = 'row' | 'column';

export interface Key {
	name: string;
	title?: string;
	type?: string;
	dateFormat: DateFormatType;
	textFormat?: {
		maxLength: number;
	};
	orderBy?: string;
	order?: 'desc' | 'asc';
	size?: number;
	showOtherValues?: boolean;
	otherValuesTitle?: string;
	style?: FieldStyle;
	visible?: boolean;
	conditionalFormattingConfiguration?: FieldConditionalFormatting[];
}

export interface FieldStyle {
	titleColor?: string;
	titleTextColor?: string;
	titleFontSize?: string;
	titleFontWeight?: string;

	cellColor?: string;
	cellTextColor?: string;
	cellFontSize?: string;
	cellFontWeight?: string;
}

export interface FieldStyleConfigs {
	[key: string]: FieldStyle;
}

export interface DateFormatType {
	interval: string;
	format?: string;
}

export interface DragedKey {
	type: KeyType;
	index: number;
	keyData: Key;
	name: string;
}

//TODO: bazı yerlerde hatalı alanları tanımlama!
export interface EncoloredField {
	key: string;
	colorFor: { header: boolean; cell: boolean };
	colorHeader: string;
	colorCell: string;
	//TODO: data grid render'da kullanılıyor. Kontrol edilmesi gerekli!
	header?: any;
	headerText?: any;
	cell?: any;
	cellText?: any;
}

export const textColorOptions = {
	basic: '#333',
	colored: '#fff',
};
export const tableField = {
	header: 'header',
	cell: 'cell',
};
export type nulldefined = null | undefined;

export interface GeneralSettingsObject {
	fontSize: string;
	fontStyle: string;
}
